export const articles = [
  {
    slug: 'blood-sugar-management-glucose-spikes',
    title: '당신이 늘 피곤한 이유, "혈당 스파이크"를 잡아라',
    summary: '식후에 몰려오는 졸음과 무기력함의 원인인 혈당 스파이크를 예방하고 관리하는 실전 팁을 알아봅니다.',
    content: `
      <h2>식후 식곤증, 단순한 피로가 아니다?</h2>
      <p>점심 식사 후 참을 수 없는 졸음이 쏟아지나요? 혹은 단 음식을 먹고 나면 반짝 에너지가 났다가 금세 무기력해지나요? 이는 단순한 피로가 아니라 혈당이 급격히 치솟았다가 떨어지는 '혈당 스파이크' 현상일 가능성이 높습니다.</p>
      <h2>혈당 스파이크가 위험한 이유</h2>
      <p>혈당이 급격하게 변동하면 우리 몸은 이를 조절하기 위해 인슐린을 과도하게 분비합니다. 이 과정이 반복되면 췌장에 무리가 가고, 혈관 세포가 손상되며 장기적으로는 인슐린 저항성이 생겨 당뇨병이나 심혈관 질환으로 이어질 수 있습니다. 또한, 급격한 혈당 하락은 가짜 허기를 유발해 과식을 하게 만드는 악순환을 만듭니다.</p>
      <h2>일상에서 실천하는 혈당 관리법</h2>
      <ol>
        <li><strong>식사 순서 바꾸기:</strong> 채소 -> 단백질 -> 탄수화물 순서로 식사하세요. 식이섬유를 먼저 섭취하면 당의 흡수 속도를 늦출 수 있습니다.</li>
        <li><strong>식후 10분 걷기:</strong> 식사 직후 가벼운 움직임은 근육이 당을 에너지로 사용하게 하여 혈당 수치를 안정시킵니다.</li>
        <li><strong>애플 사이다 비네거(사과초):</strong> 식전에 물에 희석한 식초 한 잔은 당 흡수를 억제하는 데 도움을 줄 수 있습니다.</li>
      </ol>
      <p>작은 습관의 변화가 당신의 하루 컨디션과 미래의 건강을 바꿉니다. 오늘부터 식사 순서 하나만 바꿔보는 건 어떨까요?</p>
    `
  },
  {
    slug: 'dopamine-detox-guide',
    title: '뇌의 휴식이 필요한 시대, 도파민 디톡스 시작하기',
    summary: '숏폼 영상과 SNS 중독에서 벗어나 뇌의 보상 회로를 정상화하고 집중력을 되찾는 방법을 소개합니다.',
    content: `
      <h2>자극의 과부하, 지친 당신의 뇌</h2>
      <p>스마트폰을 내려놓자마자 다시 손이 가나요? 1분 내외의 짧은 영상들을 끊임없이 넘겨보고 있지는 않나요? 우리는 지금 '도파민 과부하' 시대에 살고 있습니다. 자극적인 콘텐츠는 뇌에서 쾌락 호르몬인 도파민을 과도하게 분비시키고, 이는 평범한 일상의 즐거움을 앗아가는 원인이 됩니다.</p>
      <h2>도파민 디톡스가 필요한 증상</h2>
      <ul>
        <li>긴 글을 읽는 것이 힘들고 집중력이 눈에 띄게 떨어졌다.</li>
        <li>아무것도 하지 않고 가만히 있는 시간을 견디기 힘들다.</li>
        <li>강한 자극이 아니면 흥미를 느끼지 못한다.</li>
      </ul>
      <h2>현실적인 도파민 디톡스 실천법</h2>
      <p>무조건 스마트폰을 끊는 것은 불가능합니다. 대신 '질서'를 부여하세요.</p>
      <ol>
        <li><strong>디지털 금식 시간 정하기:</strong> 기상 직후 1시간, 취침 전 1시간은 스마트폰을 멀리하세요.</li>
        <li><strong>알림 끄기:</strong> 불필요한 앱 알림을 차단하여 주의력이 분산되는 것을 막으세요.</li>
        <li><strong>대체 활동 찾기:</strong> 종이책 읽기, 명상, 요리, 산책 등 느린 도파민을 생성하는 활동을 늘리세요.</li>
      </ol>
      <p>도파민 디톡스는 삶을 지루하게 만드는 것이 아니라, 사소한 것에서 다시 행복을 느낄 수 있도록 뇌를 재설정하는 과정입니다.</p>
    `
  },
  {
    slug: 'how-to-improve-sleep-quality',
    title: '꿀잠 자는 법: 수면의 질을 결정하는 3가지 골든타임',
    summary: '아침이 개운하지 않다면 수면 위생을 점검해야 합니다. 깊은 잠을 유도하는 과학적인 환경 조성법.',
    content: `
      <h2>잠의 양보다 질이 중요한 이유</h2>
      <p>8시간을 자도 피곤하다면 수면의 질에 문제가 있는 것입니다. 수면은 단순히 쉬는 시간이 아니라 뇌의 노폐물을 청소하고 에너지를 저장하는 필수적인 과정입니다.</p>
      <h2>깊은 수면을 위한 환경 조성</h2>
      <ol>
        <li><strong>빛의 조절:</strong> 자기 전 1시간은 밝은 조명을 끄고 간접 조명을 사용하세요. 스마트폰의 블루라이트는 수면 호르몬인 멜라토닌 분비를 방해합니다.</li>
        <li><strong>일정한 온도:</strong> 침실 온도는 약간 서늘한 18~22도가 적당합니다. 체온이 살짝 낮아져야 깊은 잠에 들기 쉽습니다.</li>
        <li><strong>마그네슘 섭취:</strong> '천연 진정제'로 불리는 마그네슘은 근육을 이완시키고 신경을 안정시켜 숙면을 돕습니다.</li>
      </ol>
      <p>질 좋은 수면은 다음 날의 집중력과 기분, 심지어 식욕 조절에도 큰 영향을 미칩니다. 오늘 밤 당신의 침실 환경을 하나만 바꿔보세요.</p>
    `
  },
  {
    slug: 'mindful-meditation-for-beginners',
    title: '하루 5분 명상으로 스트레스와 작별하는 법',
    summary: '명상이 어렵게만 느껴지는 초보자를 위한 가장 쉬운 마음 챙김 가이드.',
    content: `
      <h2>명상, 종교가 아닌 뇌 훈련입니다</h2>
      <p>명상은 복잡한 기도가 아닙니다. 지금 이 순간에 온전히 집중하는 '마음의 근육'을 키우는 훈련입니다. 수많은 실리콘밸리의 리더들이 명상을 하는 이유는 이것이 스트레스를 관리하고 창의성을 높이는 과학적인 방법이기 때문입니다.</p>
      <h2>초보자를 위한 5분 명상법</h2>
      <ol>
        <li><strong>편안하게 앉기:</strong> 허리를 펴고 앉아 눈을 감거나 시선을 낮춥니다.</li>
        <li><strong>호흡 관찰하기:</strong> 숨이 들어오고 나가는 감각에 집중합니다. 코끝의 공기 흐름이나 배의 움직임을 느껴보세요.</li>
        <li><strong>생각 흘려보내기:</strong> 잡생각이 드는 것은 자연스러운 현상입니다. 생각이 났음을 알아차리고 다시 호흡으로 부드럽게 돌아오세요.</li>
      </ol>
      <p>명상의 효과는 즉각적이지 않을 수 있지만, 매일 조금씩 실천하면 상황에 휘둘리지 않는 단단한 마음을 가질 수 있게 됩니다.</p>
    `
  },
  {
    slug: 'benefits-of-ashwagandha-wellness',
    title: '스트레스 킬러 "아슈와간다", 현대인에게 필요한 이유',
    summary: '천연 어댑토젠으로 불리는 아슈와간다의 효능과 안전한 섭취 방법.',
    content: `
      <h2>어댑토젠이란 무엇인가?</h2>
      <p>최근 웰니스 트렌드에서 가장 주목받는 단어 중 하나는 '어댑토젠(Adaptogen)'입니다. 이는 우리 몸이 스트레스에 적응하도록 돕는 천연 물질을 의미합니다. 그중에서도 아슈와간다는 수천 년간 아유르베다에서 사용되어 온 대표적인 성분입니다.</p>
      <h2>아슈와간다의 주요 효능</h2>
      <ul>
        <li><strong>코르티솔 수치 감소:</strong> 스트레스 호르몬인 코르티솔 분비를 억제하여 불안감을 완화합니다.</li>
        <li><strong>수면 질 개선:</strong> 긴장을 완화하여 더 깊고 평온한 잠을 잘 수 있게 돕습니다.</li>
        <li><strong>면역력 및 항염 효과:</strong> 신체 저항력을 높여 전반적인 건강 증진에 기여합니다.</li>
      </ul>
      <p>다만, 건강기능식품은 개인의 상태에 따라 효과가 다를 수 있으므로 전문가와 상의 후 적절한 용량을 섭취하는 것이 중요합니다.</p>
    `
  }
];